import React, { useContext,useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";

import { Grid } from "@mui/material";
import Stack from "@mui/material/Stack";
import AddIcon from "@mui/icons-material/Add";
import TableCell from "@mui/material/TableCell";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import InfoIcon from "@mui/icons-material/Info";
import Tooltip from "@mui/material/Tooltip";
import Collapse from "@mui/material/Collapse";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import { styled } from "@mui/material/styles";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import UiSearch from "../../../_uiComponents/common/form/UiSearch";
import { UiButton } from "../../../_uiComponents/common/form/UiButton";
import { Context } from "../../../../_context/Store";
import UiModal from "../../../_uiComponents/common/UiModal";
import {
     lookupTableGetRequest,
     lookupTableValueDeleteRequest,
     lookupTableValueGetRequest,
     lookupTableValueAddRequest,
     lookupTableValueListRequest
} from "../../../../_redux/_actions";
import { contextApiActions } from "../../../../_redux/_constants";
import LookupTableAddRowForm from "../forms/LookupTableAddRowForm";
import { FORM_TYPE_ADD, FORM_TYPE_EDIT } from "../../../../_helpers/constants";
import AddValuesByFileImport from "./AddValuesByFileImport";

export default function LookupTableRowManagement(props) {
     const VisuallyHiddenInput = styled("input")({
          clip: "rect(0 0 0 0)",
          clipPath: "inset(50%)",
          height: 1,
          overflow: "hidden",
          position: "absolute",
          bottom: 0,
          left: 0,
          whiteSpace: "nowrap",
          width: 1,
     });

     const [state, dispatch] = useContext(Context);
     const [page, setPage] = React.useState(1);
     const [rowsPerPage, setRowsPerPage] = React.useState(5);

     const actionDispatch = useDispatch();

   
     const { rowValueList, totalRecords, lookupSearchValue  } = useSelector((state) => {
          return {
               rowValueList: state.lookupTable.tableValueList.data,
               totalRecords: state.lookupTable.tableValueList.totalRecords,
               lookupSearchValue:state.lookupTable.searchValue,
          };
     });

     useEffect(() => {
          getLookupTableList();
          props.lookUpPage(page);
          props.lookUpPageSize(rowsPerPage);
     }, [page, rowsPerPage]);


     useEffect(() => {
          if(lookupSearchValue?.search === ""){
               setPage(1); 
          }

     }, [lookupSearchValue?.search])


     const getLookupTableList = () => {

          actionDispatch(
               lookupTableValueListRequest({
                    page: page,
                    pageSize: rowsPerPage,
                    lookupTableId: props.tableId,
                    search:lookupSearchValue?.search !== null ? lookupSearchValue?.search : ''
               }),
          );
          
     };

     //Pagination
     const handleChangePage = (event, newPage) => {
          setPage(newPage + 1);
     };

     const handleChangeRowsPerPage = (event) => {
          setRowsPerPage(event.target.value);
          setPage(1);
     };

     const uploadUsingCsv = (data) => {
          actionDispatch(
               lookupTableValueAddRequest({
                    values: data,
                    tableId: props.tableId,
                    closeFormModal: () => {},
               }),
          );
     };

     const addValueByFileImportOpen = () =>{
          dispatch({
               type: contextApiActions.UI_LARGE_MODAL_TOGGEL,
               payload: {
                    show: true,
                    heading: "Add Value By File Import",
                    children: (
                      <AddValuesByFileImport
                         tableId={props.tableId}
                      />
                    ),
               },
          });  
     }

     const addValueFormOpen = () => {
          dispatch({
               type: contextApiActions.UI_MODAL_TOGGEL,
               payload: {
                    show: true,
                    heading: "Add Value",
                    children: (
                         <LookupTableAddRowForm
                              tableId={props.tableId}
                              tableType={props.tableType}
                              type={FORM_TYPE_ADD}
                              page={page}
                              rowsPerPage={rowsPerPage}
                         />
                    ),
               },
          });
     };

     const editValueFormOpen = (id) => {
          actionDispatch(
               lookupTableValueGetRequest({
                    id,
               }),
          );

          dispatch({
               type: contextApiActions.UI_MODAL_TOGGEL,
               payload: {
                    show: true,
                    heading: "Update Value",
                    children: (
                         <LookupTableAddRowForm
                              tableType={props.tableType}
                              tableId={props.tableId}
                              id={id}
                              type={FORM_TYPE_EDIT}
                              page={page}
                              rowsPerPage={rowsPerPage}
                         />
                    ),
               },
          });
     };

     const deleteLookupTableValue = (id) => {
          dispatch({
               type: contextApiActions.UI_CONFIRMATION_TOGGEL,
               payload: {
                    show: true,
                    okFunction: () =>
                         actionDispatch(
                              lookupTableValueDeleteRequest({
                                   id,
                                   lookupTableId: props.tableId,
                                   page: page,
                                   pageSize: rowsPerPage,
                                   search:lookupSearchValue?.search !== null ? lookupSearchValue?.search : ''
                              }),
                         ),   
               },
          });
     };

     return (
          <Box sx={{ margin: 1 }}>
               <h2 className="sba-create-fact-table-heading">
                    Manage Lookup Values
               </h2>
               <div className="sba-subtable-top-btns">
                    <div className="sba-add-row-button">
                         <Button
                              variant="contained"
                              startIcon={<AddIcon />}
                              onClick={addValueFormOpen}
                         >
                              Add Value
                         </Button>
                         <Button
                              variant="contained"
                              startIcon={<AddIcon />}
                              sx={{ ml: 2 }}
                              onClick={addValueByFileImportOpen}
                         >
                              Add Values by File Import
                         </Button>
                         {/* <Button
                              component="label"
                              role={undefined}
                              variant="contained"
                              tabIndex={-1}
                              sx={{ ml: 2 }}
                              startIcon={<CloudUploadIcon />}
                         >
                              Upload file
                              <VisuallyHiddenInput
                                   type="file"
                                   accept=".csv"
                                   onChange={(e) => {
                                        const file = e.target.files[0];
                                        let uploadData = [];
                                        const reader = new FileReader();

                                        reader.onload = function (e) {
                                             const contents = e.target.result;
                                             const lines = contents.split("\n");
                                             const data = [];

                                             lines.forEach((line) => {
                                                  const values =
                                                       line.split(",");
                                                  data.push(values);
                                             });

                                             // Display the parsed data
                                             data.forEach((fileDataSet) => {
                                                  fileDataSet.forEach(
                                                       (name) => {
                                                            if (name != "") {
                                                                 uploadData.push(
                                                                      name,
                                                                 );
                                                            }
                                                       },
                                                  );
                                             });

                                             uploadUsingCsv(uploadData);
                                        };

                                        reader.readAsText(file);
                                   }}
                              />
                         </Button> */}
                    </div>
                    <UiModal
                         // handleClose={handleClose}
                         // open={openAddFieldModal}
                         heading="Add Name"
                    ></UiModal>
                    <div className="sba-subtable-search">
                         <UiSearch searchValue={lookupSearchValue}  onChange={props.getTableRowValueList} />
                    </div>
               </div>
               <div className="sba-sub-table sba-lookup-sub">
                    <Table size="small" aria-label="purchases">
                         <TableHead>
                              <TableRow>
                                   <TableCell align="left" sx={{width:'150px'}}>Key</TableCell>
                                   <TableCell align="left">Value</TableCell>
                                   <TableCell></TableCell>
                              </TableRow>
                         </TableHead>

                         <TableBody>
                              {rowValueList.map((row, index) => {
                                  
                                   return (
                                        <TableRow>
                                             <TableCell >{row.key}</TableCell>
                                             <TableCell>{row.value}</TableCell>

                                             <TableCell align="right">
                                                  <div className="sbt-data-grid__action-bar">
                                                       <Tooltip
                                                            title="Edit"
                                                            placement="top"
                                                            arrow
                                                       >
                                                            <IconButton
                                                                 onClick={() =>
                                                                      editValueFormOpen(
                                                                           row.id,
                                                                      )
                                                                 }
                                                                 aria-label="Edit"
                                                                 sx={{
                                                                      ml: 1.5,
                                                                 }}
                                                            >
                                                                 <EditIcon />
                                                            </IconButton>
                                                       </Tooltip>
                                                       <Tooltip
                                                            title="Delete"
                                                            placement="top"
                                                            arrow
                                                       >
                                                            <IconButton
                                                                 onClick={() =>
                                                                      deleteLookupTableValue(
                                                                           row.id,
                                                                      )
                                                                 }
                                                                 aria-label="Delete"
                                                                 sx={{
                                                                      ml: 0.5,
                                                                 }}
                                                            >
                                                                 <DeleteIcon color="error" />
                                                            </IconButton>
                                                       </Tooltip>
                                                  </div>
                                             </TableCell>
                                        </TableRow>
                                   );
                              })}
                         </TableBody>
                    </Table>
               </div>
               <TablePagination
                    rowsPerPageOptions={[5, 10, 15, 20, 25]}
                    component="div"
                    count={totalRecords}
                    rowsPerPage={rowsPerPage}
                    page={page - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
               />
          </Box>
     );
}
